import { render, staticRenderFns } from "./needs.html?vue&type=template&id=245283de&"
import script from "./needs.js?vue&type=script&lang=js&"
export * from "./needs.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports